import { Materialized as M, Program, summon } from "@silversea-ssc/functional-support"
import { Option } from "fp-ts/Option"

export type GenericErrorResponse<AReq, AError> = {
    request: Option<AReq>
    errorCode: AError
}

export type GenericErrorResponseEncoded<EReq> = {
    request: EReq | null
    errorCode: string
}

export type GenericErrorResponseM<EReq, AReq, AError> = M<
    Readonly<GenericErrorResponseEncoded<EReq>>,
    Readonly<GenericErrorResponse<AReq, AError>>
>

export const GenericErrorResponse = <EReq, AReq, AError>(
    Request: Program<EReq, AReq>,
    ErrorCode: Program<string, AError>,
    name: string,
): GenericErrorResponseM<EReq, AReq, AError> =>
    summon((F) =>
        F.interface(
            {
                request: F.nullable(Request(F)),
                errorCode: ErrorCode(F),
            },
            name,
        ),
    )
